<script setup lang="ts">
import { useCookieConsentStore } from "@/stores/cookieConsent";

defineOptions({
  name: "DefaultLayout",
});

const cookieStore = useCookieConsentStore();

onMounted(() => {
  if (cookieStore.shouldShowBanner) {
    cookieStore.showBanner();
  }
});

// Navigation for default theme (depth 1 is 2 level navi, depth 2 is 3 level navi, and so on)
const { loadNavigationElements } = useNavigation();
const { data } = useAsyncData("mainNavigation", () => {
  return loadNavigationElements({ depth: 1 });
});
provide("swNavigation-main-navigation", data);

const { loadNavigationElements: loadFooterNavigationElements } = useNavigation({
  type: "footer-navigation",
});
const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return loadFooterNavigationElements({ depth: 1 });
});
provide("swNavigation-footer-navigation", footerData);
</script>
<template>
  <div class="nuxt-inner">
    <LayoutHeader />
    <LayoutNotifications />
    <CookieConsentBanner />
    <main class="flex-grow non-ssr-only">
      <slot />
    </main>
    <LayoutFooter />
    <LayoutFooterOverlay />
  </div>
</template>
